import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: true,
  download: false,
  pdfFile: '',
  selectedSlideId: null,
  slides: [],
};

/** https://immerjs.github.io/immer/update-patterns/ */
export const slice = createSlice({
  name: 'slides',
  initialState,
  reducers: {
    initialStateAction: () => initialState,
    setLoadingStateAction: (state, action) => {
      state.isLoading = action.payload;
    },
    getSlidesAction: (state) => state,
    setSlidesAction: (state, action) => {
      state.slides = action.payload.slides.map((item) => ({
        ...item,
      }));
      state.pdfFile = action.payload.pdfFile;
      state.download = action.payload.download;

      state.isLoading = false;
    },
    setSelectedSlideAction: (state, action) => {
      state.selectedSlideId = action.payload;
    },
    errorTranscriptAction: (state) => state,
  },
});

export const {
  getSlidesAction,
  setSlidesAction,
  initialStateAction,
  setLoadingStateAction,
  errorTranscriptAction,
  setSelectedSlideAction,
} = slice.actions;
